import Hls from "hls.js";

import ExpandableVideo, {
  ExpandableVideoProps,
} from "@app/analytics/components/ExpandableVideo";
import IconVideoThumbnail from "@app/analytics/components/IconVideoThumbnail";

import { Card, Label, SubLabel } from "./styles";

export interface VideoMomentProps {
  clip?: ExpandableVideoProps["clip"];
  date: string;
  forcePause?: boolean;
  label: string;
  loading: boolean;
  onPlay?: ExpandableVideoProps["onPlay"];
  recordingInfo?: ExpandableVideoProps["recordingInfo"];
  state: "available" | "unavailable" | "locked";
  title: string;
  thumbnailUrl?: string | null;
}

const VideoMoment = ({
  clip,
  date,
  label,
  loading,
  recordingInfo,
  state,
  title,
  thumbnailUrl,
  ...videoProps
}: VideoMomentProps) => {
  const cannotPlayClip =
    !loading && (!clip || !recordingInfo || !Hls.isSupported());
  const videoUnavailable =
    cannotPlayClip || state != "available" || !clip || !recordingInfo;

  return (
    <Card spacing={0.5}>
      {videoUnavailable ? (
        <IconVideoThumbnail
          state={state}
          thumbnailUrl={thumbnailUrl}
          loading={loading}
        />
      ) : (
        <ExpandableVideo
          {...videoProps}
          clip={clip}
          recordingInfo={recordingInfo}
        />
      )}
      <Label>{label}</Label>
      <SubLabel>
        {date} • {title}
      </SubLabel>
    </Card>
  );
};

export default VideoMoment;
